import { alpha } from "@mui/system";
import { z } from "zod";

const styles = (theme) => ({
  boxHeader: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  containerStackedBarChart: { width: "100%", maxWidth: "600px" },
  boxBody: {
    width: "100%",
    display: "flex",
    gap: 1,
    height: "80vh",
    p: 1,
  },
  containerCloseDrawer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  buttonRefresh: {
    color: theme.palette.text.textContrast,
    borderColor: theme.palette.text.main,
    minWidth: "40px",
    padding: "10px",
    lineHeight: 1,
    "& .rotating": {
      animation: "spin 1s linear infinite",
    },
    "@keyframes spin": {
      "0%": {
        transform: "rotate(0deg)",
      },
      "100%": {
        transform: "rotate(-360deg)",
      },
    },
  },
  buttonSearch: {
    color: theme.palette.text.textContrast,
    borderColor: theme.palette.text.main,
    minWidth: "40px",
    padding: "10px",
    lineHeight: 1,
  },
  buttonSearchModal: {
    minWidth: "40px",
    padding: "10px",
    lineHeight: 1,
  },
  modalSearch: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "16px",

    width: " 90%",
    maxWidth: "500px",
    height: "400px",
    maxHeight: "90vh",
    overflow: "hidden",
  },
  modalConfigSla: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "16px",

    width: " 90%",
    maxWidth: "800px",
    height: "700px",
    maxHeight: "90vh",
    overflow: "hidden",
  },
  paperItensConfigSla: {
    height: "75%",
    p: 2,
    margin: "0 10px",
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    gap: 1,
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.colors.black.dark, 0.4)
        : theme.palette.colors.black.lighter,
  },
  containerPaperEditConfigSla: {
    display: "flex",
    borderRadius: "10px",
    alignItems: "center",
    gap: 0.5,
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.colors.black.dark, 0.4)
        : theme.palette.colors.black.lighter,
  },
  boxEditConfigSla: {
    display: "flex",
    alignItems: "center",
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.colors.black.dark, 0.4)
        : theme.palette.colors.black.lighter,
    padding: "3px 6px",
    borderRadius: "10px",
    gap: 0.5,
  },
  textFieldEditConfigSla: {
    width: "45px",
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      paddingRight: 0,
      backgroundColor: "background.paper",
    },
    "& input": {
      textAlign: "center",
      fontSize: "12px",
    },
  },
  boxTextConfigSla: {
    fontWeight: 500,
    opacity: 0.7,
    fontSize: "12px",
  },
  refConfigSla: {
    fontWeight: "bold",
    fontSize: "12px",
    opacity: 0.5,
  },
  boxTimeConfigSla: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    gap: 1,
    flexDirection: "column",
  },
  BoxExitModalConfigSla: { position: "absolute", top: "10px", right: "10px" },
  boxTitleModalConfigSla: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
  },

  paperEtapaConfigSla: {
    p: 2,
    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
  },
  boxLoadingSla: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%", // obrigatório
    width: "100%",
  },
  containerBoxClearSearch: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
  },
  boxNoTickets: {
    height: "60%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  containerSearch: { display: "flex", alignItems: "center", gap: 1, p: 2 },
  search: {
    width: "100%",
    maxWidth: 500,
    flexGrow: 1,
    fontSize: "0.90rem", // diminui fonte geral
  },
  containerTextNoTickets: {
    position: "absolute",
    left: "75%",
    top: "30%",
    transform: "translateX(-50%)",
    "@media (max-width: 700px)": {
      top: "15%",
    },
    "@media (max-width: 600px)": {
      left: "40%",
      top: "12%",
    },
    "@media (max-width: 430px)": {
      left: "40%",
      top: "10%",
    },
  },
  containerImgNoTickets: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-40%)",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  paperFluxo: {
    borderRadius: "16px",
    flex: 1,
    height: "100%",
    overflowY: "auto",
    overflowX: "hidden",
    position: "relative",
    p: 1,
  },
  containerStatusMensagem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 0.5,
  },
  paperFluxoTickets: {
    borderRadius: "16px",
    flex: 1,
    height: "100%",
    overflowY: "auto",
    position: "relative",
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.colors.black.dark, 0.4)
        : theme.palette.colors.black.lighter,
  },
  ticketNoFind: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  containerCheckBox: {
    position: "relative",
    borderRadius: "16px",
    overflow: "hidden",
    transition: "0.2s",
  },
  checkBox: {
    position: "absolute",
    top: 4,
    right: 4,
    zIndex: 2,
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.colors.black.medium
        : theme.palette.colors.black.light,
    borderRadius: "4px",
    "&:hover": {
      backgroundColor:
        theme.palette.mode === "dark"
          ? theme.palette.colors.black.light
          : theme.palette.colors.black.lighter,
    },
  },
  checkOverlay: {
    position: "absolute",
    pointerEvents: "none",
    inset: 0,
    zIndex: 1,
    transition: "0.2s",
  },
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "16px",
    p: 4,
    width: " 90%",
    maxWidth: "1000px",
    height: "700px",
    maxHeight: "90vh",
    overflow: "auto",
  },
  titleDataProtocoloModal: {
    fontWeight: "bold",
    fontSize: "14px",
    color: theme.palette.primary.main,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
  },
  titleDataClienteModal: {
    fontWeight: "bold",
    fontSize: "14px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
  },
  boxData: { display: "flex", gap: 1, alignItems: "center" },
  titleDataModal: {
    fontWeight: "bold",
    fontSize: "14px",
  },
  containerSendMensagem: {
    mt: "auto",
    pt: 2,
    display: "flex",
    flexDirection: "column",
  },
  containerActionsMensagens: {
    display: "flex",
    justifyContent: "flex-end",
    mt: 2,
    gap: 1,
  },
  containerStatusModal: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
  },
  titleModal: {
    fontWeight: "bold",
    fontSize: "20px",
    mb: 2,
  },
  paperAllTickets: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    height: "400px",
    overflow: "auto",
    p: 2,
    borderRadius: "16px",
  },
  paperTickets: {
    width: "100%",
    borderRadius: "16px",
    p: 2,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 1,
    backgroundColor: theme.palette.background.default,
  },
  containerModal: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
  },
  chipStatus: {
    minWidth: "120px",
    color: theme.palette.white.main,
  },
  titleChipModal: {
    fontWeight: "bold",
    fontSize: "10px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  containerButton: {
    mb: 2,

    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    position: "sticky",
    top: 0,
    zIndex: 10,
    backgroundColor: alpha(theme.palette.background.paper, 0.85),
    backdropFilter: "blur(3px)",
    minHeight: "80px",
  },
  boxActions: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "80px",
    p: 2,
  },
  containerActions: {
    display: "flex",
    alignItems: "center",
  },
  boxBlurGrid: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "calc(100% - 30px)",
    justifySelf: "center",
    height: "80px",
    zIndex: 2,
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.colors.black.dark)
        : alpha(theme.palette.colors.black.lighter, 0.8),
    backdropFilter: "blur(3px)",
    borderTopLeftRadius: "16px",
    "@media (max-width:1150px)": {
      width: "95%",
    },
    "@media (max-width:880px)": {
      width: "93%",
    },
    transform: "translateY(8px) translateX(7px)",
  },
  boxBlurDrawer: {
    position: "absolute",
    top: 57,
    left: 0,
    width: "calc(100% - 30px)",
    justifySelf: "center",
    height: "88px",
    zIndex: 2,
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.colors.black.dark)
        : alpha(theme.palette.colors.black.lighter, 0.8),
    backdropFilter: "blur(6px)",
    "@media (max-width:400px)": {
      width: "93%",
    },
    transform: "translateY(8px) translateX(7px)",
    borderTopLeftRadius: "16px",
  },
  titleActions: {
    fontWeight: "700",
    color: "text.secondary",
    mb: 1,
    display: "block",
    letterSpacing: "1px",
  },
  paperAction: {
    p: 2,
    mb: 1,
    transition: "0.3s",
    "&:hover": { bgcolor: "action.hover" },
    borderColor: "divider",
  },
});
export default styles;
